import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type * as current from '../../../utils/types/sharedTypes'
import type { UpBlockHandler } from '../types'
import { findBlockIdWithinStep, newId } from '../utils'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.PVRooftopNavigatorBlock> = (
  uischema,
  _,
  journey
) => {
  if (uischema.type !== CONTROL_NAME.PV_ROOF_PLANNER_CONTROL) {
    throw new Error('Expected a valid PVRoofPlanner control')
  }

  if (!journey) {
    throw new Error('Expected a valid journey')
  }

  const references = upReferences(uischema.options, journey)

  return {
    type: next.BLOCK_TYPE.PV_ROOFTOP,
    required: false,
    settings: {
      ...upCommonSettings(uischema),
      panelLifetimeYears: uischema.options?.panelLifetimeYears
    },
    references
  }
}

export const upReferences = (
  uischema: current.BlockUiSchema['options'],
  journey: current.Journey
): next.PVRooftopNavigatorBlock['references'] => {
  if (!uischema) return {}

  const keysMap: Record<
    string,
    next.PVRooftopNavigatorBlock['references'][string]['meaning']
  > = {
    relatedAvailabilityBlock: 'related-availability-check',
    relatedNumberBlock: 'related-number-input'
  }

  return Object.keys(keysMap).reduce<ReturnType<typeof upReferences>>(
    (acc, key) => {
      const reference = uischema[key]

      if (!reference) return acc

      const [stepNumber, blockName, ctrlName] = uischema[key].split('/')

      if (
        ![
          CONTROL_NAME.NUMBER_INPUT_CONTROL,
          CONTROL_NAME.AVAILABILITY_CHECK
        ].includes(ctrlName)
      ) {
        throw new Error(
          'Expected Number Input or Availability Check as reference'
        )
      }

      const referencedBlockId = findBlockIdWithinStep(
        journey,
        // The steps are numbered starting from 1, idx should be number-1
        Number(stepNumber) - 1,
        blockName
      )

      if (referencedBlockId) {
        const refId = newId<next.ReferenceId>()

        acc[refId] = {
          id: refId,
          referenceType: next.REFERENCED_TYPE.BLOCK,
          referenceId: referencedBlockId,
          meaning: keysMap[key]
        }
      }

      return acc
    },
    {}
  )
}
